export const IS_INTAKE_QUESTIONS_FORM = 'isIntakeQuestionsForm'
